
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 11.28 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.656 0a4.55 4.55 0 00-4.539 4.537c0 1.549.836 2.854 2.028 3.674C1.307 9.07 0 10.828 0 12.924v4.336a.74.74 0 00.74.74h9.795a.74.74 0 00.74-.74v-4.336c0-2.09-1.3-3.837-3.127-4.701 1.203-.818 2.045-2.13 2.045-3.686A4.548 4.548 0 005.656 0zm0 1.479a3.046 3.046 0 013.057 3.058 3.046 3.046 0 01-3.057 3.059 3.048 3.048 0 01-3.058-3.059A3.048 3.048 0 015.656 1.48zm-.082 7.626h.127c2.304 0 4.096 1.716 4.096 3.819v3.597H1.48v-3.597c0-2.103 1.79-3.819 4.094-3.819z","font-family":"sans-serif","overflow":"visible","paint-order":"stroke fill markers"}})])
          )
        }
      }
    